export default "__VITE_ASSET__DWTyzDyP__"